<template>
    <transition name="fade">
        <div class="overlay d-flex flex-column align-items-center justify-content-center" :class="promptClass">
                <div class="promptHolder py-3 px-5 radius-normal darker">
                    <div :is="selectedTemplate" @clickedOk="clickedOk" @clickedCancel="clickedCancel" :info="getRichPromptServerInfo"></div>
                </div>
        </div>
    </transition>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

import TemplateDefault from './templates/default.vue'
import InvoiceMissingConf from './templates/invoiceMissingConf.vue'

export default {
    components:{
        TemplateDefault,
        InvoiceMissingConf
    },
    computed: {
        ...mapGetters([
            'getRichPromptServerInfo',
            'getRichPromptStatuses'
        ]),
        selectedTemplate: function () {
            switch (this.getRichPromptServerInfo.type) {
                case 101:
                    return 'InvoiceMissingConf'
                    break;
                default:
                    return 'TemplateDefault'
            }

        },
        promptClass: function () {
            return this.getRichPromptStatuses.find(status => {
                return status.id == this.getRichPromptServerInfo.status
            }).label
        }
    },
    methods: {
        ...mapActions([
            'hideRichPrompt'
        ]),
        clickedOk: function () {
            this.eventHub.$emit('responeRichPrompt', 'default_ok');
        },
        clickedCancel: function () {
            this.eventHub.$emit('responeRichPrompt', 'default_cancel');
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.overlay{
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: 2000;
    transition: all 1300ms ease-in-out;
    background: rgba(0,0,0,0.5);

    .promptHolder{
        background-color: $lightest;
        width:550px;

    }
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// richPrompt.vue?5e0d136c